import React, { useEffect, useState } from "react";
import RegisteredPatientUI from "../../components/patient/RegisteredPatientUI";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { fetchAllSchemesOnBoard } from "../../models/schemeSlice";

const RegisteredPatientContainer: React.FC = () => {
  const [scheme, setScheme] = useState<any>(null);
  const [registrationNumber, setRegistrationNumber] = useState<string>("");
  const {
    hospital: selectedHospital,
    auth,
    scheme: allSchemes,
  } = useSelector((state: RootState) => state);
  const dispatch = useDispatch<AppDispatch>();

  const handleSchemeChange = (e: any) => {
    setScheme(e.target.value);
  };

  const handleRegistrationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRegistrationNumber(e.target.value);
  };

  const handleSubmit = () => {
    const payload = {
      scheme,
      registrationNumber,
    };
  };

  useEffect(() => {
    if (selectedHospital?.selectedHospital?.value) {
      dispatch(
        fetchAllSchemesOnBoard({
          accessToken: auth.accessToken || "",
          healthCareId: selectedHospital?.selectedHospital?.value,
        }),
      );
    }
  }, [selectedHospital?.selectedHospital?.value]);

  useEffect(() => {
  if (allSchemes?.schemeOnBoarding?.length) {
    const filteredSchemes = allSchemes?.schemeOnBoarding?.filter((s: any) =>
      ["CGHS NEW", "ECHS", "CAPF NEW"].includes(s?.schemeMetaDataName)
    );
    const defaultSchemeId = filteredSchemes?.[0]?.schemeMetaDataId || null;
    setScheme(defaultSchemeId);
  }
}, [allSchemes?.schemeOnBoarding]);

  return (
    <RegisteredPatientUI
      scheme={scheme}
      registrationNumber={registrationNumber}
      onSchemeChange={handleSchemeChange}
      onRegistrationChange={handleRegistrationChange}
      onSubmit={handleSubmit}
      schemes={allSchemes?.schemeOnBoarding || []}
    />
  );
};

export default RegisteredPatientContainer;
